type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const YoutubeIcon = ({
    width =20,
    height=20,
    fill="none"
}: Props) =>{
    return (
<svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.582 7.18587C21.352 6.32543 20.6745 5.64781 19.814 5.4178C18.2545 5 12 5 12 5C12 5 5.746 5 4.1865 5.4178C3.3255 5.64781 2.648 6.32543 2.418 7.18587C2 8.74579 2 11.9998 2 11.9998C2 11.9998 2 15.2542 2.418 16.8141C2.648 17.6746 3.3255 18.3522 4.1865 18.5822C5.746 19 12 19 12 19C12 19 18.2545 19 19.814 18.5822C20.6745 18.3522 21.352 17.6746 21.582 16.8141C22 15.2542 22 11.9998 22 11.9998C22 11.9998 22 8.74579 21.582 7.18587Z" fill="#FF0000"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.95459 15.0189L15.1821 12.0454L9.95459 9.07135V15.0189Z" fill="white"/>
</svg>





    )
}

export default YoutubeIcon;